import * as React from 'react';
import { Col, ControlLabel, FormControl, FormGroup, Row } from 'react-bootstrap';
import CountryCodePhoneNumberInput from '../../../../components/common/CountryCodePhoneNumberInput';
import FieldInfoIcon from '../../../../components/common/FieldInfoIcon';
import LanguageSelect from '../../../../components/common/LanguageSelect';
import ValidatableFormGroup from '../../../../components/common/ValidatableFormGroup';
import { Translate } from '../../../../shared/LanguageService';

const PhotographerFormComponentInfo = (props: any) => {
    const { apiUrl } = window.appConfig;

    return (
        <fieldset>
            <legend>{Translate('photographers/modal/form/legend/photographer')}</legend>
            <Row>
                <Col md={props.user.profileImageReference ? 8 : 12}>
                    <FormGroup controlId="photographerName">
                        <ControlLabel>
                            {Translate('photographers/modal/form/input-label/name')}
                        </ControlLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            name="name"
                            required
                            value={props.user && props.user.name ? props.user.name : ''}
                            onChange={props.onChange}
                        />
                    </FormGroup>
                    <ValidatableFormGroup required validationKey="username" errors={props.errors}>
                        <ControlLabel>
                            {Translate('photographers/modal/form/input-label/username')}
                        </ControlLabel>
                        <FormControl
                            type="text"
                            name="username"
                            error={props.errors ? props.errors.username : ''}
                            value={props.user && props.user.username ? props.user.username : ''}
                            onChange={props.onChange}
                        />
                    </ValidatableFormGroup>
                    <ValidatableFormGroup required validationKey="email" errors={props.errors}>
                        <ControlLabel>
                            {Translate('photographers/modal/form/input-label/email-address')}
                        </ControlLabel>
                        <FormControl
                            type="email"
                            name="email"
                            error={props.errors ? props.errors.email : ''}
                            value={
                                props.user && props.user.email
                                    ? props.user.email
                                    : props.user.username
                            }
                            onChange={props.onChange}
                        />
                    </ValidatableFormGroup>
                    <ValidatableFormGroup validationKey="phoneNumber" errors={props.errors}>
                        <ControlLabel>
                            {Translate('photographers/modal/form/input-label/enter-phone-number')}
                        </ControlLabel>
                        <FieldInfoIcon
                            title={Translate('popover/info/title/phonenumber')}
                            content={Translate('popover/info/content/phonenumber')}
                        />
                        <CountryCodePhoneNumberInput
                            value={props.user.phoneNumber}
                            onChange={(val) => {
                                props.onChange({
                                    target: { name: 'phoneNumber', value: val }
                                });
                            }}
                        />
                    </ValidatableFormGroup>
                    <FormGroup controlId="photographerLang" className="required">
                        <LanguageSelect
                            onChange={props.onChange}
                            languageKey={
                                props.user && props.user.languageKey ? props.user.languageKey : ''
                            }
                            errors={props.errors}
                            languages={props.availableLanguages}
                        />
                    </FormGroup>
                </Col>
                {props.user.profileImageReference && (
                    <Col className="profile-image-preview" md={3}>
                        <img src={`${apiUrl}/file/${props.user.profileImageReference}`} />
                    </Col>
                )}
            </Row>
        </fieldset>
    );
};

export default PhotographerFormComponentInfo;
